<script setup>
import { useChannelIcon, useChannelBrandColor } from './provider';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const channelIcon = useChannelIcon(props.inbox);
const channelColor = useChannelBrandColor(props.inbox);
</script>

<template>
  <Icon :icon="channelIcon" :style="{ color: channelColor }" />
</template>
